// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"21c8692c","206":"b1e883e4","222":"0be44a80","287":"58a51149","288":"f0dee549","596":"2daee63d","752":"faf84895","844":"17b1dce3","853":"a60b4a22","856":"1c8041a5"}[chunkId] + ".chunk.js";
};